import { render, staticRenderFns } from "./CustomerVehicleSelector.vue?vue&type=template&id=2d4e0642&scoped=true"
import script from "./CustomerVehicleSelector.vue?vue&type=script&lang=ts"
export * from "./CustomerVehicleSelector.vue?vue&type=script&lang=ts"
import style0 from "./CustomerVehicleSelector.vue?vue&type=style&index=0&id=2d4e0642&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e0642",
  null
  
)

export default component.exports